﻿class WishlistButton extends HTMLElement {}

customElements.define('wishlist-button', WishlistButton);

var WE_PRODUCT_CACHE_PREFIX = 'we_product_ctx_';
var WE_PRODUCT_CACHE_SHOPIFY_PREFIX = 'we_product_ctx_shopify_';
var WE_CATEGORY_CACHE_KEY = 'we_last_category_ctx';
var WE_CATEGORY_L1_ANCHOR_KEY = 'we_category_l1_anchor';
var WE_CATEGORY_DRILLDOWN_KEY = 'we_category_drilldown';

function weIsUsableCategoryName(name) {
  if (!name) {
    return false;
  }

  return String(name).trim().toLowerCase() !== 'all products';
}

function weNormalizeCategoryContext(source) {
  source = source || {};
  var l1 = weIsUsableCategoryName(source.l1_category_name) ? source.l1_category_name : '';
  var l2 = weIsUsableCategoryName(source.l2_category_name) ? source.l2_category_name : '';

  return {
    id: String(source.id || source.page_collection_id || ''),
    name: source.name || '',
    collection_handle: String(source.collection_handle || ''),
    page_collection_id: String(source.page_collection_id || source.id || ''),
    l1_category_name: l1,
    l2_category_name: l2,
    l1_category_id: l1 ? String(source.l1_category_id || '') : '',
    l2_category_id: l2 ? String(source.l2_category_id || '') : '',
    product_count: source.product_count,
    items: source.items
  };
}

function weGetCachedCategoryContext() {
  try {
    var raw = sessionStorage.getItem(WE_CATEGORY_CACHE_KEY);
    return raw ? weNormalizeCategoryContext(JSON.parse(raw)) : weNormalizeCategoryContext({});
  } catch (error) {
    return weNormalizeCategoryContext({});
  }
}

function weCacheCategoryContext(source) {
  source = weNormalizeCategoryContext(source || {});

  try {
    sessionStorage.setItem(WE_CATEGORY_CACHE_KEY, JSON.stringify(source));
  } catch (error) {
    /* ignore */
  }

  return source;
}

function weCameFromCollectionReferrer(handle) {
  handle = String(handle || '');

  if (!handle) {
    return false;
  }

  try {
    return String(document.referrer || '').indexOf('/collections/' + handle) > -1;
  } catch (error) {
    return false;
  }
}

function weHasCategoryDrillDownIntent() {
  try {
    return sessionStorage.getItem(WE_CATEGORY_DRILLDOWN_KEY) === '1';
  } catch (error) {
    return false;
  }
}

function weClearCategoryDrillDownIntent() {
  try {
    sessionStorage.removeItem(WE_CATEGORY_DRILLDOWN_KEY);
  } catch (error) {
    /* ignore */
  }
}

function weSetCategoryDrillDownIntent() {
  try {
    sessionStorage.setItem(WE_CATEGORY_DRILLDOWN_KEY, '1');
  } catch (error) {
    /* ignore */
  }
}

function weGetL1Anchor() {
  try {
    var raw = sessionStorage.getItem(WE_CATEGORY_L1_ANCHOR_KEY);
    return raw ? weNormalizeCategoryContext(JSON.parse(raw)) : weNormalizeCategoryContext({});
  } catch (error) {
    return weNormalizeCategoryContext({});
  }
}

function weCacheL1Anchor(source) {
  source = weNormalizeCategoryContext(source || {});

  if (!source.l1_category_name || source.l2_category_name) {
    return;
  }

  try {
    sessionStorage.setItem(
      WE_CATEGORY_L1_ANCHOR_KEY,
      JSON.stringify({
        l1_category_name: source.l1_category_name,
        l1_category_id: source.l1_category_id,
        page_collection_id: source.page_collection_id,
        collection_handle: source.collection_handle
      })
    );
  } catch (error) {
    /* ignore */
  }
}

function weClearL1Anchor() {
  try {
    sessionStorage.removeItem(WE_CATEGORY_L1_ANCHOR_KEY);
  } catch (error) {
    /* ignore */
  }
}

function weShouldApplyCategoryDrillDown(current, previous) {
  var anchor;
  current = weNormalizeCategoryContext(current);
  previous = weNormalizeCategoryContext(previous);

  if (!current.page_collection_id || current.l2_category_name) {
    return false;
  }

  if (weHasCategoryDrillDownIntent()) {
    return true;
  }

  anchor = weGetL1Anchor();

  if (anchor.l1_category_name && anchor.page_collection_id && current.page_collection_id !== anchor.page_collection_id) {
    return true;
  }

  if (!previous.l1_category_name || previous.l2_category_name) {
    return false;
  }

  if (current.page_collection_id === previous.page_collection_id) {
    return false;
  }

  return weCameFromCollectionReferrer(previous.collection_handle);
}

function weResolveCategoryContext(current) {
  var previous;
  var anchor;
  var l1Name;
  var l1Id;

  current = weNormalizeCategoryContext(current || {});
  previous = weGetCachedCategoryContext();

  if (current.l1_category_name && current.l2_category_name) {
    weClearCategoryDrillDownIntent();
    return weCacheCategoryContext(current);
  }

  if (weShouldApplyCategoryDrillDown(current, previous)) {
    anchor = weGetL1Anchor();
    l1Name = anchor.l1_category_name || previous.l1_category_name;
    l1Id = anchor.l1_category_id || previous.l1_category_id;
    weClearCategoryDrillDownIntent();

    return weCacheCategoryContext(
      weNormalizeCategoryContext({
        id: current.id,
        name: current.name,
        collection_handle: current.collection_handle,
        page_collection_id: current.page_collection_id,
        l1_category_name: l1Name,
        l1_category_id: l1Id,
        l2_category_name: current.name || current.l1_category_name || '',
        l2_category_id: current.page_collection_id,
        product_count: weResolveCategoryProductCount(current),
        items: current.items
      })
    );
  }

  weClearCategoryDrillDownIntent();
  weCacheL1Anchor(current);
  return weCacheCategoryContext(current);
}

function weResolveCategoryProductCount(collection) {
  var count = Number(collection.product_count);
  var itemCount = (collection.items && collection.items.length) || 0;

  if (!isNaN(count) && count > 0) {
    return count;
  }

  if (itemCount > 0) {
    return itemCount;
  }

  return isNaN(count) ? 0 : count;
}

function weBuildCategoryPayloadFromDom(root) {
  var productList = (root || document).querySelector('[data-webengage-category-list]');

  if (!productList) {
    return null;
  }

  try {
    var collection = JSON.parse(productList.textContent || '{}');

    return {
      l1_category_name: collection.l1_category_name || collection.name || '',
      l2_category_name: collection.l2_category_name || '',
      l1_category_id: String(collection.l1_category_id || collection.id || ''),
      l2_category_id: String(collection.l2_category_id || ''),
      product_count: weResolveCategoryProductCount(collection),
      name: collection.name,
      id: collection.id,
      collection_handle: collection.collection_handle || '',
      page_collection_id: String(collection.page_collection_id || collection.id || ''),
      items: collection.items
    };
  } catch (error) {
    return null;
  }
}

function wePublishCategoryViewedFromDom(root) {
  var categoryPayload;

  if (typeof Shopify === 'undefined' || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') {
    return;
  }

  categoryPayload = weBuildCategoryPayloadFromDom(root);

  if (!categoryPayload) {
    return;
  }

  if (typeof window.__weResolveCategoryContext === 'function') {
    categoryPayload = window.__weResolveCategoryContext(categoryPayload);
  } else if (typeof window.__weCacheCategoryContext === 'function') {
    categoryPayload = window.__weCacheCategoryContext(categoryPayload);
  }

  Shopify.analytics.publish('bestseller:category_viewed', {
    l1_category_name: categoryPayload.l1_category_name || '',
    l2_category_name: categoryPayload.l2_category_name || '',
    l1_category_id: String(categoryPayload.l1_category_id || ''),
    l2_category_id: String(categoryPayload.l2_category_id || ''),
    product_count: categoryPayload.product_count,
    name: categoryPayload.name,
    id: categoryPayload.id,
    collection_handle: categoryPayload.collection_handle || '',
    page_collection_id: String(categoryPayload.page_collection_id || categoryPayload.id || ''),
    items: categoryPayload.items
  });
}

function weInitCategoryDrillDownTracking() {
  document.addEventListener(
    'click',
    function (event) {
      var collectionLink = event.target.closest('a[href*="/collections/"]');

      if (!collectionLink) {
        return;
      }

      if (event.target.closest('header, .header, [data-header-section]')) {
        weClearL1Anchor();
        weClearCategoryDrillDownIntent();
        return;
      }

      if (
        event.target.closest(
          '.collection-categories, .facets, .facets-drawer, .facets-sidebar, .accordion__content, .quick_category'
        )
      ) {
        weSetCategoryDrillDownIntent();
      }
    },
    true
  );

  document.documentElement.addEventListener('theme:loading:end', function () {
    if (String(window.location.pathname || '').indexOf('/collections/') === -1) {
      return;
    }

    wePublishCategoryViewedFromDom(document);
    weSeedProductAnalyticsCacheFromDom(document);
  });
}

function weInitCategoryAnalytics() {
  weInitCategoryDrillDownTracking();

  if (typeof window.__wePublish === 'function') {
    window.__wePublish(function () {
      wePublishCategoryViewedFromDom(document);
    });
    return;
  }

  if (String(window.location.pathname || '').indexOf('/collections/') > -1) {
    wePublishCategoryViewedFromDom(document);
  }
}

function weApplyActiveCategoryToProductPayload(payload) {
  payload = payload || {};
  var section = String(payload.section || '');

  if (section !== 'PLP') {
    return payload;
  }

  var active = weGetCachedCategoryContext();

  if (!active.l1_category_name) {
    return payload;
  }

  payload.l1_category_name = active.l1_category_name;
  payload.l1_category_id = active.l1_category_id;

  if (active.l2_category_name) {
    payload.l2_category_name = active.l2_category_name;
    payload.l2_category_id = active.l2_category_id;
  } else {
    payload.l2_category_name = '';
    payload.l2_category_id = '';
  }

  return payload;
}

window.__weResolveCategoryContext = weResolveCategoryContext;
window.__weCacheCategoryContext = weCacheCategoryContext;
window.__weGetCachedCategoryContext = weGetCachedCategoryContext;
window.__weApplyActiveCategoryToProductPayload = weApplyActiveCategoryToProductPayload;
window.__wePublishCategoryViewedFromDom = wePublishCategoryViewedFromDom;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', weInitCategoryAnalytics);
} else {
  weInitCategoryAnalytics();
}

function weFindVariantRow(variants, lookupId) {
  variants = variants || [];
  lookupId = String(lookupId || '');
  var index;

  for (index = 0; index < variants.length; index += 1) {
    if (String(variants[index].shopify_variant_id) === lookupId) {
      return variants[index];
    }
    if (String(variants[index].variant_id) === lookupId) {
      return variants[index];
    }
  }

  return null;
}

function weGetProductCache(lookupId) {
  lookupId = String(lookupId || '');

  try {
    var raw = sessionStorage.getItem(WE_PRODUCT_CACHE_SHOPIFY_PREFIX + lookupId);

    if (raw) {
      return JSON.parse(raw);
    }

    raw = sessionStorage.getItem(WE_PRODUCT_CACHE_PREFIX + lookupId);
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    return {};
  }
}

function weCacheProductContext(payload) {
  payload = payload || {};

  try {
    var data = JSON.stringify(payload);

    if (payload.shopify_product_id) {
      sessionStorage.setItem(WE_PRODUCT_CACHE_SHOPIFY_PREFIX + String(payload.shopify_product_id), data);
    }

    if (payload.product_id) {
      sessionStorage.setItem(WE_PRODUCT_CACHE_PREFIX + String(payload.product_id), data);
    }
  } catch (error) {
    /* ignore */
  }
}

function weGetProductAnalyticsFromDom(shopifyProductId) {
  shopifyProductId = String(shopifyProductId || '');
  var selectors;
  var index;
  var node;
  var payload;

  if (!shopifyProductId) {
    return null;
  }

  selectors = [
    'script.webengage-product-analytics[data-product-id="' + shopifyProductId + '"]',
    'script.webengage-wishlist-analytics[data-product-id="' + shopifyProductId + '"]'
  ];

  for (index = 0; index < selectors.length; index += 1) {
    node = document.querySelector(selectors[index]);

    if (!node) {
      continue;
    }

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      /* try next node */
    }
  }

  node = document.getElementById('webengage-product-payload');

  if (node) {
    try {
      payload = JSON.parse(node.textContent || '{}');

      if (String(payload.shopify_product_id) === shopifyProductId) {
        return payload;
      }
    } catch (error) {
      return null;
    }
  }

  return null;
}

function weMergeProductContextFields(cached, domBase) {
  cached = cached || {};
  domBase = domBase || {};
  var merged = {};
  var key;
  var specFields = ['fit', 'sleeve', 'material', 'gender', 'default_color', 'color'];
  var categoryFields = [
    'l1_category_name',
    'l2_category_name',
    'l1_category_id',
    'l2_category_id',
    'product_name',
    'image_url',
    'sub_brand_name',
    'section',
    'view_type'
  ];

  for (key in domBase) {
    if (Object.prototype.hasOwnProperty.call(domBase, key)) {
      merged[key] = domBase[key];
    }
  }

  for (key in cached) {
    if (Object.prototype.hasOwnProperty.call(cached, key)) {
      merged[key] = cached[key];
    }
  }

  specFields.forEach(function (field) {
    if (!merged[field] && domBase[field]) {
      merged[field] = domBase[field];
    }

    if (!merged[field] && cached[field]) {
      merged[field] = cached[field];
    }
  });

  categoryFields.forEach(function (field) {
    if (!merged[field] && cached[field]) {
      merged[field] = cached[field];
    }

    if (!merged[field] && domBase[field]) {
      merged[field] = domBase[field];
    }
  });

  if (!merged.variants || !merged.variants.length) {
    merged.variants = cached.variants || domBase.variants || [];
  }

  return merged;
}

function weGetProductContext(shopifyProductId) {
  var cached = weGetProductCache(shopifyProductId);
  var domBase = weGetProductAnalyticsFromDom(shopifyProductId);

  if (!domBase) {
    return cached || {};
  }

  if (!cached || !cached.product_id) {
    return domBase;
  }

  return weMergeProductContextFields(cached, domBase);
}

function weSeedProductAnalyticsCacheFromDom(root) {
  root = root || document;
  var nodes = root.querySelectorAll(
    'script.webengage-product-analytics[data-product-id], script.webengage-wishlist-analytics[data-product-id]'
  );
  var payloadNode = root.getElementById ? root.getElementById('webengage-product-payload') : null;
  var index;

  for (index = 0; index < nodes.length; index += 1) {
    try {
      weCacheProductContext(
        weApplyActiveCategoryToProductPayload(JSON.parse(nodes[index].textContent || '{}'))
      );
    } catch (error) {
      /* ignore invalid JSON */
    }
  }

  if (payloadNode) {
    try {
      weCacheProductContext(
        weApplyActiveCategoryToProductPayload(JSON.parse(payloadNode.textContent || '{}'))
      );
    } catch (error) {
      /* ignore */
    }
  }
}

function weInitProductAnalyticsCacheSeeding() {
  weSeedProductAnalyticsCacheFromDom(document);

  if (!window.MutationObserver) {
    return;
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) {
          return;
        }

        weSeedProductAnalyticsCacheFromDom(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', weInitProductAnalyticsCacheSeeding);
} else {
  weInitProductAnalyticsCacheSeeding();
}

var WE_ANALYTICS_PRODUCT_VIEW = 'webengage-analytics';
var WE_CART_ENRICH_TIMEOUT_MS = 3500;
var weProductAnalyticsFetchByHandle = {};

function weShopifyStoreRoot() {
  return typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
}

function weCartLineItemHandle(lineItem) {
  lineItem = lineItem || {};
  var handle = String(lineItem.handle || lineItem.product_handle || '').trim();

  if (handle) {
    return handle;
  }

  var url = String(lineItem.url || '');
  var match = url.match(/\/products\/([^/?#]+)/i);

  return match ? decodeURIComponent(match[1]) : '';
}

function weParseProductAnalyticsJson(text) {
  text = String(text || '').trim();

  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch (error) {
    return null;
  }
}

function weFetchProductAnalyticsByHandle(handle, callback) {
  handle = String(handle || '').trim();
  callback = callback || function () {};

  if (!handle) {
    callback(null);
    return;
  }

  if (weProductAnalyticsFetchByHandle[handle]) {
    weProductAnalyticsFetchByHandle[handle].then(callback).catch(function () {
      callback(null);
    });
    return;
  }

  var url =
    weShopifyStoreRoot() + 'products/' + encodeURIComponent(handle) + '?view=' + WE_ANALYTICS_PRODUCT_VIEW;
  var promise = fetch(url, { credentials: 'same-origin' })
    .then(function (response) {
      return response.ok ? response.text() : '';
    })
    .then(function (text) {
      var payload = weParseProductAnalyticsJson(text);

      if (payload && payload.shopify_product_id) {
        weCacheProductContext(weApplyActiveCategoryToProductPayload(payload));
      }

      return payload;
    })
    .catch(function () {
      return null;
    });

  weProductAnalyticsFetchByHandle[handle] = promise;
  promise.then(callback);
}

function weCartProductDetailIsComplete(item, mapLineItem) {
  item = item || {};
  var mapped = mapLineItem(item);
  var cached = weGetProductContext(item.product_id);

  if (!String(mapped.product_id || '').trim() || !String(mapped.variant_id || '').trim()) {
    return false;
  }

  if (!String(cached.product_id || '').trim()) {
    return false;
  }

  return Boolean(weFindVariantRow(cached.variants, item.variant_id));
}

function weEnrichCartProductContexts(cart, mapLineItem, callback) {
  cart = cart || {};
  callback = callback || function () {};
  mapLineItem =
    mapLineItem ||
    function () {
      return {};
    };

  var items = cart.items || [];

  if (!items.length) {
    callback(cart);
    return;
  }

  var pending = 0;
  var finished = false;
  var timerId;
  var index;
  var item;
  var handle;
  var handlesRequested = {};

  function finish() {
    if (finished) {
      return;
    }

    finished = true;

    if (timerId) {
      clearTimeout(timerId);
    }

    weSeedProductAnalyticsCacheFromDom(document);
    callback(cart);
  }

  function onFetchDone() {
    pending -= 1;

    if (pending <= 0) {
      finish();
    }
  }

  timerId = setTimeout(finish, WE_CART_ENRICH_TIMEOUT_MS);

  for (index = 0; index < items.length; index += 1) {
    item = items[index];

    if (weCartProductDetailIsComplete(item, mapLineItem)) {
      continue;
    }

    handle = weCartLineItemHandle(item);

    if (!handle || handlesRequested[handle]) {
      continue;
    }

    handlesRequested[handle] = true;
    pending += 1;
    weFetchProductAnalyticsByHandle(handle, onFetchDone);
  }

  if (pending === 0) {
    clearTimeout(timerId);
    finish();
  }
}

function weNormalizeImageUrl(url) {
  url = String(url || '').trim();

  if (!url) {
    return '';
  }

  if (url.indexOf('//') === 0) {
    return 'https:' + url;
  }

  return url;
}

function weNormalizeProductPricing(mrp, totalPayable, discount) {
  mrp = Number(mrp) || 0;
  totalPayable = Number(totalPayable) || 0;
  discount = Number(discount);
  if (isNaN(discount) || (discount === 0 && mrp > totalPayable)) {
    discount = mrp > totalPayable ? mrp - totalPayable : 0;
  }

  return {
    mrp: mrp,
    total_payable: totalPayable,
    discount_on_mrp: discount
  };
}

function weGetUsableProductCategories(source) {
  source = source || {};
  var l1 = source.l1_category_name || '';
  var l2 = source.l2_category_name || '';

  if (String(l1).trim().toLowerCase() === 'all products') {
    l1 = '';
  }

  if (String(l2).trim().toLowerCase() === 'all products') {
    l2 = '';
  }

  return {
    l1_category_name: l1,
    l2_category_name: l2,
    l1_category_id: l1 ? String(source.l1_category_id || '') : '',
    l2_category_id: l2 ? String(source.l2_category_id || '') : ''
  };
}

var WE_MULTI_PRODUCT_STRING_FIELDS = [
  'product_id',
  'product_name',
  'variant_id',
  'sub_brand_name',
  'l1_category_name',
  'l2_category_name',
  'l1_category_id',
  'l2_category_id',
  'color',
  'fit',
  'sleeve',
  'material',
  'gender',
  'size',
  'image_url'
];

function weAggregateProductDetailField(details, field) {
  var values = [];

  (details || []).forEach(function (item) {
    if (item[field]) {
      values.push(String(item[field]));
    }
  });

  return values.filter(function (value, index) {
    return values.indexOf(value) === index;
  }).join(', ');
}

function weApplyAggregatedProductFields(target, details, fields) {
  target = target || {};
  fields = fields || WE_MULTI_PRODUCT_STRING_FIELDS;

  fields.forEach(function (field) {
    target[field] = weAggregateProductDetailField(details, field);
  });

  return target;
}

document.addEventListener('variant:change', function (event) {
  var variant = event.detail && event.detail.variant;
  if (!variant || !variant.id) return;

  document.querySelectorAll('wishlist-button').forEach(function (button) {
    button.dataset.variantId = String(variant.id);
  });
});

(function () {
  var WISHLIST_API_BASE = 'https://livewishlist.scriptengine.net/api';
  var WISHLIST_STORE_ID_KEY = 'we_wishlist_store_id';
  var WISHLIST_ANALYTICS_VIEW = 'webengage-analytics';
  var WISHLIST_ENRICH_TIMEOUT_MS = 3500;
  var wishlistAnalyticsFetchCache = {};
  var lastWishlistViewedAt = 0;
  var lastWishlistActionKey = '';
  var lastWishlistActionAt = 0;

  function weShopifyRoot() {
    return typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function weWishlistItemHandle(item) {
    item = item || {};
    var handle = String(item.handle || item.product_handle || item.productHandle || '').trim();

    if (handle) {
      return handle;
    }

    var url = String(item.url || item.product_url || item.link || '');
    var match = url.match(/\/products\/([^/?#]+)/i);

    return match ? decodeURIComponent(match[1]) : '';
  }

  function weWishlistShopifyProductId(item) {
    item = item || {};
    var shopifyId = String(item.shopify_id || item.shopify_product_id || '');

    if (shopifyId) {
      return shopifyId;
    }

    if (item.product_id && String(item.product_id).length >= 12) {
      return String(item.product_id);
    }

    return '';
  }

  function weWishlistLineIsComplete(mapped) {
    mapped = mapped || {};
    return Boolean(String(mapped.product_id || '').trim() && String(mapped.variant_id || '').trim());
  }

  function weParseWishlistAnalyticsResponse(text) {
    text = String(text || '').trim();

    if (!text) {
      return null;
    }

    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  }

  function weFetchWishlistProductAnalytics(handle, callback) {
    handle = String(handle || '').trim();
    callback = callback || function () {};

    if (!handle) {
      callback(null);
      return;
    }

    if (wishlistAnalyticsFetchCache[handle]) {
      wishlistAnalyticsFetchCache[handle].then(callback).catch(function () {
        callback(null);
      });
      return;
    }

    var url =
      weShopifyRoot() + 'products/' + encodeURIComponent(handle) + '?view=' + WISHLIST_ANALYTICS_VIEW;
    var promise = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (text) {
        var payload = weParseWishlistAnalyticsResponse(text);

        if (payload && payload.shopify_product_id) {
          payload.section = payload.section || 'Wishlist';
          weCacheProductContext(weApplyActiveCategoryToProductPayload(payload));
        }

        return payload;
      })
      .catch(function () {
        return null;
      });

    wishlistAnalyticsFetchCache[handle] = promise;
    promise.then(callback);
  }

  function weEnrichWishlistItems(items, callback) {
    items = items || [];
    callback = callback || function () {};

    if (!items.length) {
      callback(items);
      return;
    }

    var pending = 0;
    var finished = false;
    var timerId;
    var index;
    var item;
    var mapped;
    var handle;

    function finish() {
      if (finished) {
        return;
      }

      finished = true;

      if (timerId) {
        clearTimeout(timerId);
      }

      weSeedProductAnalyticsCacheFromDom(document);
      callback(items);
    }

    function onFetchDone() {
      pending -= 1;

      if (pending <= 0) {
        finish();
      }
    }

    timerId = setTimeout(finish, WISHLIST_ENRICH_TIMEOUT_MS);

    for (index = 0; index < items.length; index += 1) {
      item = items[index];
      mapped = mapWishlistApiItem(item);

      if (weWishlistLineIsComplete(mapped)) {
        continue;
      }

      handle = weWishlistItemHandle(item);

      if (!handle) {
        continue;
      }

      pending += 1;
      weFetchWishlistProductAnalytics(handle, onFetchDone);
    }

    if (pending === 0) {
      clearTimeout(timerId);
      finish();
    }
  }

  function getWishlistCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie.split(';');

    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) {
        try {
          return decodeURIComponent(part.substring(prefix.length));
        } catch (error) {
          return part.substring(prefix.length);
        }
      }
    }

    return '';
  }

  function getWishlistCustomerRecords() {
    var node = document.getElementById('wishlist-engine-customer-records');

    try {
      return JSON.parse((node && node.textContent) || '{}');
    } catch (error) {
      return {};
    }
  }

  function publishAnalyticsEvent(eventName, payload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish(eventName, payload);
  }

  function getWishlistTotalFromDom() {
    var node = document.querySelector('.wishlist-total-count');
    var total;

    if (node) {
      total = parseInt(node.getAttribute('data-total') || node.textContent, 10);
      if (!isNaN(total)) {
        return total;
      }
    }

    total = parseInt(getWishlistCookie('WISHLIST_TOTAL'), 10);
    return isNaN(total) ? 0 : total;
  }

  function buildWishlistRequestBody(extra) {
    var records = getWishlistCustomerRecords();
    var body = {
      uuid: getWishlistCookie('WISHLIST_UUID') || '',
      ip_address: getWishlistCookie('WISHLIST_IP_ADDRESS') || '',
      customer_id: records.id || '',
      customers: records,
      shopify_store_id: sessionStorage.getItem(WISHLIST_STORE_ID_KEY) || '',
      shopify_store: typeof Shopify !== 'undefined' ? Shopify.shop : '',
      search: '',
      active_currency: (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) || '',
      share_id: '',
      shopify_local_language: (typeof Shopify !== 'undefined' && Shopify.locale) || 'en'
    };

    if (extra) {
      Object.keys(extra).forEach(function (key) {
        body[key] = extra[key];
      });
    }

    return body;
  }

  function wishlistApiPost(path, body) {
    return fetch(WISHLIST_API_BASE + path, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json();
    });
  }

  function ensureWishlistStoreId(callback) {
    var cached = sessionStorage.getItem(WISHLIST_STORE_ID_KEY);

    if (cached) {
      callback(cached);
      return;
    }

    wishlistApiPost('/apps-config', buildWishlistRequestBody({ shop: typeof Shopify !== 'undefined' ? Shopify.shop : '' }))
      .then(function (response) {
        var storeId = response && response.data && response.data.id ? String(response.data.id) : '';

        if (storeId) {
          sessionStorage.setItem(WISHLIST_STORE_ID_KEY, storeId);
        }

        callback(storeId);
      })
      .catch(function () {
        callback('');
      });
  }

  function mapWishlistApiItem(item) {
    item = item || {};
    var shopifyProductId = weWishlistShopifyProductId(item);
    var shopifyVariantId = String(item.shopify_variant_id || item.variant_id || '');
    var styleProductId = '';
    var cached = weGetProductContext(shopifyProductId);
    var variantRow = weFindVariantRow(cached.variants, shopifyVariantId);
    var categories = weGetUsableProductCategories(cached);
    var variants = item.variants || {};
    var variant = variants[shopifyVariantId] || variants[item.shopify_variant_id] || {};
    var price = Number(variant.price || item.price || 0);
    var compareAt = Number(variant.compare_at_price || variant.compare_at || price);
    var lineDiscount = compareAt > price ? compareAt - price : 0;
    var mrp = Number((variantRow && variantRow.mrp) || cached.mrp) || compareAt;
    var totalPayable = Number((variantRow && variantRow.total_payable) || cached.total_payable) || price;
    var discountSource = variantRow && variantRow.discount_on_mrp != null && variantRow.discount_on_mrp !== ''
      ? variantRow.discount_on_mrp
      : cached.discount_on_mrp;
    var discountVal = discountSource != null && discountSource !== ''
      ? Number(discountSource)
      : lineDiscount;
    var pricing = weNormalizeProductPricing(mrp, totalPayable, discountVal);
    var quantity = Number(item.quntity || item.quantity || 1);

    if (isNaN(quantity) || quantity <= 0) {
      quantity = 1;
    }

    styleProductId = String(cached.product_id || item.style_id || '');

    if (!styleProductId && item.product_id && String(item.product_id) !== shopifyProductId) {
      styleProductId = String(item.product_id);
    }

    return {
      shopify_product_id: shopifyProductId,
      shopify_variant_id: shopifyVariantId,
      product_id: styleProductId,
      product_name: cached.product_name || item.title || item.product_name || '',
      variant_id: String((variantRow && variantRow.variant_id) || item.sku || item.variant_sku || ''),
      image_url: variant.image_src || item.image || cached.image_url || '',
      sub_brand_name: cached.sub_brand_name || item.vendor || '',
      l1_category_name: categories.l1_category_name,
      l2_category_name: categories.l2_category_name,
      l1_category_id: categories.l1_category_id,
      l2_category_id: categories.l2_category_id,
      mrp: pricing.mrp,
      discount_on_mrp: pricing.discount_on_mrp,
      total_payable: pricing.total_payable,
      in_stock: variantRow ? !!variantRow.in_stock : (cached.in_stock !== undefined ? !!cached.in_stock : true),
      color: (variantRow && variantRow.color) || cached.color || '',
      fit: cached.fit || '',
      sleeve: cached.sleeve || '',
      material: cached.material || '',
      gender: cached.gender || '',
      size: (variantRow && variantRow.size) || cached.size || '',
      section: cached.section || 'Wishlist',
      view_type: cached.view_type || 'normal',
      quantity: quantity
    };
  }

  function weCacheWishlistProductContexts(items) {
    (items || []).forEach(function (item) {
      var payload = mapWishlistActionPayload(item);

      if (!payload || !payload.shopify_product_id) {
        return;
      }

      payload.section = payload.section || 'Wishlist';
      weCacheProductContext(payload);
    });
  }

  function mapWishlistActionPayload(product) {
    if (!product) {
      return null;
    }

    var shopifyProductId = String(
      product.shopify_id || product.shopify_product_id || product.id || product.product_id || ''
    );
    var shopifyVariantId = String(product.shopify_variant_id || product.variant_id || product.variant || '');
    var cached = weGetProductContext(shopifyProductId);
    var payload = mapWishlistApiItem({
      shopify_id: shopifyProductId,
      shopify_variant_id: shopifyVariantId,
      title: product.title || product.product_name || product.name,
      product_name: product.product_name || product.name,
      sku: product.sku,
      price: product.price,
      compare_at_price: product.compare_at_price || product.compare_at,
      vendor: product.vendor,
      image: product.image || product.image_src,
      quantity: product.quntity || product.quantity || 1,
      variants: product.variants || {}
    });

    payload.shopify_product_id = shopifyProductId;
    payload.shopify_variant_id = shopifyVariantId;
    payload.variants = (cached && cached.variants) || [];
    return payload;
  }

  function mapWishlistCallbackProduct(product) {
    var payload = mapWishlistActionPayload(product);

    if (!payload) {
      return null;
    }

    return {
      product_id: payload.product_id,
      product_name: payload.product_name,
      variant_id: payload.variant_id
    };
  }

  function buildWishlistSummary(items, meta) {
    var productDetails = [];
    var subtotal = 0;
    var index;

    items = items || [];
    meta = meta || {};

    for (index = 0; index < items.length; index += 1) {
      var mapped = mapWishlistApiItem(items[index]);

      if (!weWishlistLineIsComplete(mapped)) {
        continue;
      }

      productDetails.push(mapped);
      subtotal += mapped.total_payable * (mapped.quantity || 1);
    }

    subtotal = Math.round(subtotal * 100) / 100;

    var summary = {
      total_items_in_wishlist: productDetails.length,
      subtotal: subtotal,
      total_payable: subtotal,
      product_details: productDetails
    };

    weApplyAggregatedProductFields(summary, productDetails);

    if (meta.action) {
      summary.action = meta.action;
    }

    return summary;
  }

  function fetchWishlistItems(callback) {
    ensureWishlistStoreId(function (storeId) {
      var body = buildWishlistRequestBody();
      body.shopify_store_id = storeId;

      wishlistApiPost('/apps-wishlist', body)
        .then(function (response) {
          callback((response && response.data) || []);
        })
        .catch(function () {
          wishlistApiPost('/get-all-product', body)
            .then(function (fallbackResponse) {
              callback((fallbackResponse && fallbackResponse.data) || []);
            })
            .catch(function () {
              callback([]);
            });
        });
    });
  }

  function publishWishlistUpdated(action, changedProduct) {
    fetchWishlistItems(function (items) {
      weCacheWishlistProductContexts(items);
      weSeedProductAnalyticsCacheFromDom(document);

      var meta = {
        action: action,
        total_items_in_wishlist: getWishlistTotalFromDom() || items.length
      };

      if (changedProduct) {
        meta.product_id = changedProduct.product_id;
        meta.product_name = changedProduct.product_name;
        meta.variant_id = changedProduct.variant_id;
      }

      weEnrichWishlistItems(items, function () {
        publishAnalyticsEvent('bestseller:wishlist_updated', buildWishlistSummary(items, meta));
      });
    });
  }

  function publishWishlistViewed() {
    var now = Date.now();

    if (now - lastWishlistViewedAt < 2000) {
      return;
    }

    fetchWishlistItems(function (items) {
      weCacheWishlistProductContexts(items);
      weSeedProductAnalyticsCacheFromDom(document);

      weEnrichWishlistItems(items, function () {
        lastWishlistViewedAt = Date.now();
        publishAnalyticsEvent('bestseller:wishlist_viewed', buildWishlistSummary(items, {
          total_items_in_wishlist: getWishlistTotalFromDom() || items.length
        }));
      });
    });
  }

  function isWishlistPage() {
    var path = window.location.pathname;
    return path === '/pages/wishlist' || path.indexOf('/apps/wishlist') === 0;
  }

  function initWishlistPageViewTracking() {
    if (!isWishlistPage()) {
      return;
    }

    var published = false;

    function schedulePublish() {
      if (published) {
        return;
      }

      published = true;
      setTimeout(publishWishlistViewed, 800);
    }

    var observer = new MutationObserver(function () {
      var container = document.querySelector('.wishlistajaxLoad, .wishlist-row');

      if (
        container &&
        container.querySelector('[id^="wishlist_page_"], .wh-list-column, .wh-grid-column, .wishlsitnoitem')
      ) {
        schedulePublish();
      }
    });

    var page = document.querySelector('.wishlist-page');

    if (page) {
      observer.observe(page, { childList: true, subtree: true });
    }

    setTimeout(schedulePublish, 2500);
  }

  function shouldPublishWishlistAction(action, payload) {
    if (!payload) {
      return false;
    }

    var key =
      action +
      ':' +
      String(payload.shopify_product_id || payload.product_id || '') +
      ':' +
      String(payload.shopify_variant_id || payload.variant_id || '');
    var now = Date.now();

    if (key && key === lastWishlistActionKey && now - lastWishlistActionAt < 3000) {
      return false;
    }

    lastWishlistActionKey = key;
    lastWishlistActionAt = now;
    return true;
  }

  window.wishlistCallback = function (data) {
    data = data || {};
    var actionMap = {
      ADD: 'add',
      REMOVE: 'remove',
      MOVETOCART: 'move_to_cart'
    };
    var action = actionMap[data.event] || String(data.event || '').toLowerCase();
    var actionPayload = mapWishlistActionPayload(data.product);

    if (action === 'add' && shouldPublishWishlistAction('add', actionPayload)) {
      publishAnalyticsEvent('add_to_wishlist', actionPayload);
    } else if (action === 'remove' && shouldPublishWishlistAction('remove', actionPayload)) {
      publishAnalyticsEvent('remove_from_wishlist', actionPayload);
    } else if (action === 'move_to_cart' && actionPayload) {
      actionPayload.section = 'Wishlist';
      weCacheProductContext(actionPayload);
      window.__wePendingCartSection = 'Wishlist';

      setTimeout(function () {
        if (typeof window.__fetchAndPublishCartUpdated === 'function') {
          window.__fetchAndPublishCartUpdated();
        }
      }, 450);
    }

    setTimeout(function () {
      publishWishlistUpdated(action, mapWishlistCallbackProduct(data.product));
    }, 300);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPageViewTracking);
  } else {
    initWishlistPageViewTracking();
  }
})();

(function () {
  var PRODUCT_CACHE_PREFIX = 'we_product_ctx_';
  var PRODUCT_CACHE_SHOPIFY_PREFIX = 'we_product_ctx_shopify_';

  function getThemeProductCache(productId) {
    productId = String(productId || '');

    try {
      var raw = sessionStorage.getItem(PRODUCT_CACHE_SHOPIFY_PREFIX + productId);

      if (raw) {
        return JSON.parse(raw);
      }

      raw = sessionStorage.getItem(PRODUCT_CACHE_PREFIX + productId);
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  }

  function centsToAmount(cents) {
    return Number(cents || 0) / 100;
  }

  function normalizeProductPricing(mrp, totalPayable, discount) {
    mrp = Number(mrp) || 0;
    totalPayable = Number(totalPayable) || 0;
    discount = Number(discount);
    if (isNaN(discount) || (discount === 0 && mrp > totalPayable)) {
      discount = mrp > totalPayable ? mrp - totalPayable : 0;
    }

    return {
      mrp: mrp,
      total_payable: totalPayable,
      discount_on_mrp: discount
    };
  }

  function mapCartLineForCheckout(item) {
    item = item || {};
    var cached = weGetProductContext(item.product_id);
    var variantRow = weFindVariantRow(cached.variants, item.variant_id);
    var price = centsToAmount(item.final_price || item.price);
    var compareAt = centsToAmount(item.original_price || item.price);
    var lineDiscount = compareAt > price ? compareAt - price : 0;
    var mrp = Number((variantRow && variantRow.mrp) || cached.mrp) || compareAt;
    var totalPayable = Number((variantRow && variantRow.total_payable) || cached.total_payable) || price;
    var discountSource = variantRow && variantRow.discount_on_mrp != null && variantRow.discount_on_mrp !== ''
      ? variantRow.discount_on_mrp
      : cached.discount_on_mrp;
    var discountVal = discountSource != null && discountSource !== ''
      ? Number(discountSource)
      : lineDiscount;
    var pricing = normalizeProductPricing(mrp, totalPayable, discountVal);

    return {
      shopify_product_id: String(item.product_id || ''),
      shopify_variant_id: String(item.variant_id || ''),
      product_id: String(cached.product_id || ''),
      product_name: item.product_title || cached.product_name || '',
      variant_id: String((variantRow && variantRow.variant_id) || item.sku || ''),
      image_url: item.image || item.featured_image || cached.image_url || '',
      sub_brand_name: item.vendor || cached.sub_brand_name || '',
      l1_category_name: cached.l1_category_name || '',
      l2_category_name: cached.l2_category_name || '',
      l1_category_id: String(cached.l1_category_id || ''),
      l2_category_id: String(cached.l2_category_id || ''),
      mrp: pricing.mrp,
      discount_on_mrp: pricing.discount_on_mrp,
      total_payable: pricing.total_payable,
      in_stock: cached.in_stock !== undefined ? !!cached.in_stock : true,
      color: cached.color || '',
      fit: cached.fit || '',
      sleeve: cached.sleeve || '',
      material: cached.material || '',
      gender: cached.gender || '',
      size: (variantRow && variantRow.size) || cached.size || item.variant_title || '',
      section: cached.section || '',
      quantity: Number(item.quantity) || 1
    };
  }

  function isWishlistPagePath() {
    var path = window.location.pathname;
    return path === '/pages/wishlist' || path.indexOf('/apps/wishlist') === 0;
  }

  function resolveCartSection(baseEvent) {
    if (window.__wePendingCartSection) {
      var pending = window.__wePendingCartSection;
      window.__wePendingCartSection = '';
      return pending;
    }

    if (baseEvent === 'line-item:change') {
      return 'Cart';
    }

    if (isWishlistPagePath()) {
      return 'Wishlist';
    }

    var path = window.location.pathname;

    if (path.indexOf('/products/') !== -1) {
      return 'PDP';
    }

    if (path.indexOf('/collections/') !== -1) {
      return 'PLP';
    }

    if (path === '/cart' || path.indexOf('/cart/') === 0) {
      return 'Cart';
    }

    return 'PLP';
  }

  var lastCartLinesByKey = {};

  function snapshotCartLines(cart) {
    var map = {};
    var items = (cart && cart.items) || [];
    var i;
    var item;
    var key;

    for (i = 0; i < items.length; i += 1) {
      item = items[i];
      key = String(item.key || item.variant_id || item.id || i);
      map[key] = item;
    }

    return map;
  }

  function findChangedCartLine(cart) {
    var items = (cart && cart.items) || [];
    var next = snapshotCartLines(cart);
    var i;
    var item;
    var key;
    var prev;
    var changed = null;

    for (i = 0; i < items.length; i += 1) {
      item = items[i];
      key = String(item.key || item.variant_id || item.id || i);
      prev = lastCartLinesByKey[key];

      if (!prev || Number(prev.quantity) !== Number(item.quantity)) {
        changed = item;
        break;
      }
    }

    if (!changed) {
      for (key in lastCartLinesByKey) {
        if (!Object.prototype.hasOwnProperty.call(lastCartLinesByKey, key)) {
          continue;
        }

        if (!next[key]) {
          changed = lastCartLinesByKey[key];
          break;
        }
      }
    }

    lastCartLinesByKey = next;
    return changed || items[0] || null;
  }

  function getCheckoutItemsCount(details, fallback) {
    var total = 0;

    (details || []).forEach(function (item) {
      total += Number(item.quantity) || 1;
    });

    if (total) {
      return total;
    }

    return Number(fallback) || 0;
  }

  function getCartDiscountBreakdown(cart) {
    cart = cart || {};
    var apps = cart.cart_level_discount_applications || [];
    var couponNames = [];
    var appCouponValue = 0;
    var promoNames = [];
    var appPromoValue = 0;
    var allocationCouponValue = 0;
    var allocationPromoValue = 0;
    var index;

    for (index = 0; index < apps.length; index += 1) {
      var app = apps[index];
      var title = app.title || '';
      var amount = centsToAmount(app.total_allocated_amount || 0);
      var type = String(app.type || '').toLowerCase();

      if (type === 'discount_code' || type === 'code') {
        if (title) {
          couponNames.push(title);
        }
        appCouponValue += amount;
      } else {
        if (title) {
          promoNames.push(title);
        }
        appPromoValue += amount;
      }
    }

    (cart.items || []).forEach(function (item) {
      var allocations = item.line_level_discount_allocations || item.discount_allocations || [];

      allocations.forEach(function (allocation) {
        var discountApp = allocation.discount_application || allocation.discountApplication || {};
        var value = centsToAmount(allocation.amount || 0);
        var discountType = String(discountApp.type || '').toLowerCase();
        var discountTitle = discountApp.title || '';

        if (discountType === 'discount_code' || discountType === 'code') {
          if (discountTitle && couponNames.indexOf(discountTitle) === -1) {
            couponNames.push(discountTitle);
          }
          allocationCouponValue += value;
        } else {
          if (discountTitle && promoNames.indexOf(discountTitle) === -1) {
            promoNames.push(discountTitle);
          }
          allocationPromoValue += value;
        }
      });
    });

    var couponValue = allocationCouponValue > 0 ? allocationCouponValue : appCouponValue;
    var promoValue = allocationPromoValue > 0 ? allocationPromoValue : appPromoValue;
    var totalDiscount = centsToAmount(cart.total_discount || 0);

    if (totalDiscount > 0 && couponValue === 0 && promoValue === 0) {
      if (promoNames.length) {
        promoValue = totalDiscount;
      } else if (couponNames.length) {
        couponValue = totalDiscount;
      } else {
        promoValue = totalDiscount;
      }
    }

    return {
      coupon_name: couponNames.join(', '),
      coupon_value: couponValue,
      promotion_name: promoNames.join(', '),
      promotion_value: promoValue
    };
  }

  function buildCheckoutPayloadFromCart(cart) {
    cart = cart || {};
    var items = cart.items || [];
    var productDetails = items.map(mapCartLineForCheckout);
    var discounts = getCartDiscountBreakdown(cart);
    var subtotal = centsToAmount(cart.items_subtotal_price);
    var totalPayable = centsToAmount(cart.total_price);
    var tax = 0;

    if (cart.total_tax != null && cart.total_tax !== '') {
      tax = centsToAmount(cart.total_tax);
    } else if (totalPayable > subtotal) {
      tax = totalPayable - subtotal;
    }

    var payload = {
      cart_id: String(cart.token || ''),
      total_items_in_cart: getCheckoutItemsCount(productDetails, cart.item_count),
      subtotal: subtotal,
      tax: tax,
      total_payable: totalPayable,
      coupon_name: discounts.coupon_name,
      coupon_value: discounts.coupon_value,
      promotion_name: discounts.promotion_name,
      promotion_value: discounts.promotion_value,
      checkout_url: '',
      product_details: productDetails
    };

    weApplyAggregatedProductFields(payload, productDetails);
    return payload;
  }

  function publishCheckoutInitiatedFromCart() {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    fetch((Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
        .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        weEnrichCartProductContexts(cart, mapCartLineForCheckout, function (enrichedCart) {
          Shopify.analytics.publish('bestseller:checkout_initiated', buildCheckoutPayloadFromCart(enrichedCart));
        });
      })
      .catch(function () {});
  }

  function buildCartSummaryFromCart(cart, changedLine, options) {
    cart = cart || {};
    options = options || {};
    var items = cart.items || [];
    var productDetails = items.map(mapCartLineForCheckout);
    var subtotal = centsToAmount(cart.items_subtotal_price);
    var totalPayable = centsToAmount(cart.total_price);
    var tax = 0;
    var payload;

    if (cart.total_tax != null && cart.total_tax !== '') {
      tax = centsToAmount(cart.total_tax);
    } else if (totalPayable > subtotal) {
      tax = totalPayable - subtotal;
    }

    payload = {
      cart_id: String(cart.token || ''),
      section: options.section || resolveCartSection(''),
      total_items_in_cart: Number(cart.item_count) || 0,
      subtotal: subtotal,
      tax: tax,
      total_payable: totalPayable,
      product_details: productDetails
    };

    weApplyAggregatedProductFields(payload, productDetails);
    return payload;
  }

  function publishCartAnalyticsEvent(eventName, cart, summaryOptions) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    if (!cart || !Array.isArray(cart.items)) {
      return;
    }

    weEnrichCartProductContexts(cart, mapCartLineForCheckout, function (enrichedCart) {
      Shopify.analytics.publish(
        eventName,
        buildCartSummaryFromCart(enrichedCart, enrichedCart.items[0] || null, summaryOptions || {})
      );
    });
  }

  function fetchAndPublishCartAnalytics(eventName) {
    fetch((Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (response) {
          return response.json();
        })
      .then(function (cart) {
        if (eventName === 'bestseller:cart_updated') {
          var section = resolveCartSection('');
          var summaryOptions = { section: section };

          if (section === 'Wishlist') {
            summaryOptions.action = 'add';
          }

          weEnrichCartProductContexts(cart, mapCartLineForCheckout, function (enrichedCart) {
            Shopify.analytics.publish(
              eventName,
              buildCartSummaryFromCart(enrichedCart, findChangedCartLine(enrichedCart), summaryOptions)
            );
          });
          return;
        }

        publishCartAnalyticsEvent(eventName, cart);
      })
      .catch(function () {});
  }

  window.__fetchAndPublishCartUpdated = function () {
    fetchAndPublishCartAnalytics('bestseller:cart_updated');
  };

  var lastCartViewedAt = 0;

  function publishCartViewed(cart) {
    var now = Date.now();

    if (now - lastCartViewedAt < 2000) {
      return;
    }

    lastCartViewedAt = now;

    if (cart && Array.isArray(cart.items)) {
      publishCartAnalyticsEvent('bestseller:cart_viewed', cart);
      return;
    }

    fetchAndPublishCartAnalytics('bestseller:cart_viewed');
  }

  function getCartActionFromBaseEvent(baseEvent) {
    if (baseEvent === 'variant:add') {
      return 'add';
    }

    if (baseEvent === 'line-item:change') {
      return 'update';
    }

    return '';
  }

  document.addEventListener('cart:change', function (event) {
    var detail = event.detail || {};
    var cart = detail.cart;
    var payload;

    if (!cart || !Array.isArray(cart.items)) {
      fetchAndPublishCartAnalytics('bestseller:cart_updated');
      return;
    }

    var changedLine = findChangedCartLine(cart);
    var section = resolveCartSection(detail.baseEvent || '');
    var action = getCartActionFromBaseEvent(detail.baseEvent);

    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    weEnrichCartProductContexts(cart, mapCartLineForCheckout, function (enrichedCart) {
      var payload = buildCartSummaryFromCart(enrichedCart, changedLine, { section: section });

      if (action) {
        payload.action = action;
      }

      Shopify.analytics.publish('bestseller:cart_updated', payload);
    });
  });

  window.addEventListener('view_cart', function () {
    publishCartViewed();
  });

  function initCartPageViewTracking() {
    var path = window.location.pathname;

    if (path !== '/cart' && path.indexOf('/cart/') !== 0) {
      return;
    }

    setTimeout(function () {
      publishCartViewed();
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPageViewTracking);
  } else {
    initCartPageViewTracking();
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');

      if (!target) {
        return;
      }

      if (target.tagName === 'A' && target.href && target.href.indexOf('/checkout') === -1) {
        return;
      }

      publishCheckoutInitiatedFromCart();
    },
    true
  );
})();

(function () {
  var lastProductSearchedKey = '';

  function publishProductSearchedEvent(payload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish('bestseller:product_searched', payload);
  }

  function getSearchTermFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return (params.get('q') || params.get('query') || '').trim();
    } catch (error) {
      return '';
    }
  }

  function getProductCountFromTitle() {
    var title = document.title || '';
    var match = title.match(/(\d+)\s+results?\s+found/i);

    if (!match) {
      return null;
    }

    return parseInt(match[1], 10);
  }

  function isSearchPage() {
    var path = window.location.pathname;
    return path === '/search' || path.indexOf('/search/') === 0;
  }

  function shouldSkipProductSearched(searchTerm) {
    var key = String(searchTerm).toLowerCase();

    if (lastProductSearchedKey === key) {
      return true;
    }

    lastProductSearchedKey = key;
    return false;
  }

  function publishProductSearchedFromSearchPage() {
    if (!isSearchPage()) {
      return false;
    }

    var searchTerm = getSearchTermFromUrl();
    var productCount = getProductCountFromTitle();

    if (!searchTerm || productCount === null || isNaN(productCount)) {
      return false;
    }

    if (shouldSkipProductSearched(searchTerm)) {
      return true;
    }

    publishProductSearchedEvent({
      search_term: searchTerm,
      product_count: productCount
    });

    return true;
  }

  function initSearchPageTracking() {
    if (!isSearchPage()) {
      return;
    }

    if (publishProductSearchedFromSearchPage()) {
      return;
    }

    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;

      if (publishProductSearchedFromSearchPage() || attempts >= 8) {
        window.clearInterval(interval);
      }
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPageTracking);
  } else {
    initSearchPageTracking();
  }
})();

(function () {
  var PRODUCT_CACHE_PREFIX = 'we_product_ctx_';
  var lastProductViewedKey = '';
  var lastProductViewedAt = 0;

  function publishAnalyticsEvent(eventName, payload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish(eventName, payload);
  }

  function resolveProductViewSection(explicitSection, basePayload) {
    if (explicitSection) {
      return explicitSection;
    }

    if (basePayload && basePayload.section) {
      return basePayload.section;
    }

    var path = window.location.pathname;

    if (path.indexOf('/products/') !== -1) {
      var ref = document.referrer || '';

      try {
        var refUrl = new URL(ref);

        if (refUrl.hostname === window.location.hostname) {
          if (refUrl.pathname.indexOf('/collections/') !== -1) {
            return 'PLP';
          }

          if (refUrl.pathname === '/' || refUrl.pathname === '') {
            return 'Home';
          }
        }
      } catch (error) {
        /* ignore */
      }

      return 'PDP';
    }

    return 'PLP';
  }

  function getCartItemCount(callback) {
    var cartCountNode = document.querySelector('cart-count');

    if (cartCountNode) {
      var domCount = parseInt(String(cartCountNode.textContent || '').trim(), 10);

      if (!isNaN(domCount)) {
        callback(domCount);
        return;
      }
    }

    var root = typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

    fetch(root + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        callback(Number(cart.item_count) || 0);
      })
      .catch(function () {
        callback(0);
      });
  }

  function buildProductViewedPayload(basePayload, variantId, options) {
    basePayload = basePayload || {};
    options = options || {};

    var variantRow = weFindVariantRow(basePayload.variants, variantId);

    if (!variantRow) {
      variantRow = (basePayload.variants || [])[0] || {};
    }

    var payload = weApplyActiveCategoryToProductPayload({
      product_id: String(basePayload.product_id || ''),
      shopify_product_id: String(basePayload.shopify_product_id || ''),
      shopify_variant_id: String(variantRow.shopify_variant_id || variantId || ''),
      product_name: basePayload.product_name || '',
      image_url: weNormalizeImageUrl(basePayload.image_url),
      sub_brand_name: basePayload.sub_brand_name || '',
      l1_category_name: basePayload.l1_category_name || '',
      l2_category_name: basePayload.l2_category_name || '',
      l1_category_id: String(basePayload.l1_category_id || ''),
      l2_category_id: String(basePayload.l2_category_id || ''),
      section: resolveProductViewSection(options.section, basePayload),
      view_type: options.view_type || basePayload.view_type || 'normal',
      variant_id: String(variantRow.variant_id || variantId || ''),
      mrp: Number(variantRow.mrp) || 0,
      total_payable: Number(variantRow.total_payable) || 0,
      discount_on_mrp: Number(variantRow.discount_on_mrp) || 0,
      in_stock: !!variantRow.in_stock,
      size: variantRow.size || '',
      color: variantRow.color || basePayload.default_color || '',
      fit: basePayload.fit || '',
      sleeve: basePayload.sleeve || '',
      material: basePayload.material || '',
      gender: basePayload.gender || '',
      total_items_in_cart: Number(options.total_items_in_cart) || 0,
      variants: basePayload.variants || []
    });

    return payload;
  }

  function shouldSkipProductViewed(payload) {
    var key = String(payload.product_id) + ':' + String(payload.section);
    var now = Date.now();

    if (lastProductViewedKey === key && now - lastProductViewedAt < 2000) {
      return true;
    }

    lastProductViewedKey = key;
    lastProductViewedAt = now;
    return false;
  }

  window.__wePublishProductViewed = function (basePayload, variantId, options) {
    getCartItemCount(function (cartCount) {
      options = options || {};
      options.total_items_in_cart = cartCount;

      var payload = buildProductViewedPayload(basePayload, variantId, options);

      if (shouldSkipProductViewed(payload)) {
        return;
      }

      publishAnalyticsEvent('bestseller:product_viewed', payload);
      weCacheProductContext(payload);
    });
  };

  document.addEventListener(
    'click',
    function (event) {
      var quickBuyButton = event.target.closest('.product-card__quick-add-button');

      if (!quickBuyButton) {
        return;
      }

      var card = quickBuyButton.closest('product-card');

      if (!card) {
        return;
      }

      var analyticsNode = card.querySelector('script.webengage-product-analytics');

      if (!analyticsNode) {
        return;
      }

      try {
        var basePayload = JSON.parse(analyticsNode.textContent || '{}');
        var variants = basePayload.variants || [];
        var variantRow = variants[0] || {};

        window.__wePublishProductViewed(basePayload, variantRow.shopify_variant_id || variantRow.variant_id, {
          section: basePayload.section || 'PLP',
          view_type: 'quick'
        });
      } catch (error) {
        /* ignore */
      }
    },
    true
  );
})();
(function initWishlistCountVisibility() {
  const SELECTOR = '.wishlist-h-count, .wishlist-total-count';

  const getCount = (el) => {
    const fromAttr = el.getAttribute('data-total');
    if (fromAttr !== null && fromAttr !== '') {
      const parsed = parseInt(fromAttr, 10);
      if (Number.isFinite(parsed)) return parsed;
    }
    return parseInt(el.textContent.trim(), 10) || 0;
  };

  const updateEl = (el) => {
    const isEmpty = getCount(el) <= 0;
    el.hidden = false;
    el.classList.toggle('is-empty', isEmpty);
  };

  const observeEl = (el) => {
    if (el.__wishlistCountObserved) return;
    el.__wishlistCountObserved = true;
    updateEl(el);
    new MutationObserver(() => updateEl(el)).observe(el, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-total', 'hidden']
    });
  };

  const scan = (root) => {
    if (root.nodeType !== 1) return;
    if (root.matches?.(SELECTOR)) observeEl(root);
    root.querySelectorAll?.(SELECTOR).forEach(observeEl);
  };

  const init = () => {
    scan(document.body);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(scan);
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function initWishlistEmptyState() {
  const EMPTY_SELECTOR = '.wishlsitnoitem';
  const TEMPLATE_ID = 'wishlist-empty-state-template';

  const syncWishlistEmptyFooter = () => {
    const isEnhanced = Boolean(document.querySelector('.wishlist-empty-state--enhanced'));
    document.body.classList.toggle('wishlist-empty-enhanced', isEnhanced);
  };

  const enhance = (el) => {
    if (el.dataset.wishlistEmptyEnhanced === 'true') return;

    const template = document.getElementById(TEMPLATE_ID);
    if (!template) return;

    el.dataset.wishlistEmptyEnhanced = 'true';
    el.classList.add('wishlist-empty-state--enhanced');
    el.replaceChildren(template.content.cloneNode(true));
    syncWishlistEmptyFooter();
  };

  const scan = (root) => {
    if (root.nodeType !== 1) return;
    if (root.matches?.(EMPTY_SELECTOR)) enhance(root);
    root.querySelectorAll?.(EMPTY_SELECTOR).forEach(enhance);
    syncWishlistEmptyFooter();
  };

  const init = () => {
    scan(document.body);
    syncWishlistEmptyFooter();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(scan);
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          syncWishlistEmptyFooter();
        }
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Collection quick category sticky bar behavior
 * - scrolling down: hide
 * - scrolling up: show
 * - scroll stop: show
 */
(function initCollectionQuickCategoryStickyBar() {
  const DESKTOP_BAR_SELECTOR = '.quick_category.hide_on_mob';
  const MOBILE_BAR_SELECTOR = '.collection-toolbar';
  const DESKTOP_MQ = '(min-width: 1000px)';
  const MOBILE_MQ = '(max-width: 999px)';

  const resolveMobileStickyBarEl = () => {
    return document.querySelector(MOBILE_BAR_SELECTOR);
  };

  const getStickyAreaHeight = () => {
    const root = getComputedStyle(document.documentElement);
    const num = (name) => {
      const raw = root.getPropertyValue(name).trim();
      const parsed = parseFloat(raw);
      return Number.isFinite(parsed) ? parsed : 0;
    };
    return Math.max(
      num('--sticky-area-height'),
      num('--wigmix-mobile-header-height'),
      num('--liquid-mobile-header-height'),
      num('--collection-plp-sort-sticky-top-measured'),
    );
  };

  const setupOne = ({ barSelector, resolveBar, mediaQuery }) => {
    const bar =
      typeof resolveBar === 'function' ? resolveBar() : document.querySelector(barSelector);
    if (!bar) return;

    const mq = window.matchMedia(mediaQuery);
    let lastY = window.scrollY || 0;
    let pendingY = lastY;
    let rafId = 0;
    let scrollStopTimer = 0;
    let abortController = null;
    let isHidden = false;
    let isStuck = false;
    let lastDirection = 0; // 1 = down, -1 = up

    const show = () => {
      if (!isHidden) return;
      isHidden = false;
      bar.classList.remove('is-hidden');
    };
    const hide = () => {
      if (isHidden) return;
      isHidden = true;
      bar.classList.add('is-hidden');
    };

    const setStuck = (next) => {
      if (isStuck === next) return;
      isStuck = next;
      bar.classList.toggle('is-stuck', isStuck);

      // When not stuck, always show the bar (avoid weird hidden state near the top).
      if (!isStuck) show();
    };

    const updateStuckState = () => {
      const stickyTop = getStickyAreaHeight();
      const top = bar.getBoundingClientRect().top;

      // Hysteresis prevents flicker near the sticky threshold.
      const STUCK_ENTER_PX = 1;
      const STUCK_LEAVE_PX = 12;

      if (!isStuck) {
        if (top <= stickyTop + STUCK_ENTER_PX) setStuck(true);
      } else {
        if (top > stickyTop + STUCK_LEAVE_PX) setStuck(false);
      }
    };

    const scheduleScrollStopShow = () => {
      window.clearTimeout(scrollStopTimer);
      // Slightly longer debounce avoids flashing on tiny scroll pauses (trackpads/inertia).
      scrollStopTimer = window.setTimeout(() => {
        // Only force-show when the bar is in sticky mode.
        if (isStuck) show();
      }, 260);
    };

    const processScroll = () => {
      rafId = 0;
      const y = pendingY;
      const delta = y - lastY;
      lastY = y;

      updateStuckState();

      // Before the bar becomes sticky, keep it stable (no hide/show).
      if (!isStuck) return;

      const DIRECTION_THRESHOLD = 6;
      if (delta > DIRECTION_THRESHOLD) {
        lastDirection = 1;
        hide();
      } else if (delta < -DIRECTION_THRESHOLD) {
        lastDirection = -1;
        show();
      } else {
        // Ignore micro-movements to prevent jitter.
      }

      // Requirement: when scrolling stops, the bar should show (even if last direction was down).
      scheduleScrollStopShow();
    };

    const onScroll = () => {
      pendingY = window.scrollY || 0;
      if (!rafId) rafId = requestAnimationFrame(processScroll);
    };

    const enable = () => {
      lastY = window.scrollY || 0;
      pendingY = lastY;
      isHidden = bar.classList.contains('is-hidden');
      isStuck = bar.classList.contains('is-stuck');
      lastDirection = 0;
      show();
      updateStuckState();

      abortController?.abort();
      abortController = new AbortController();

      window.addEventListener('scroll', onScroll, { passive: true, signal: abortController.signal });
    };

    const disable = () => {
      abortController?.abort();
      abortController = null;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = 0;
      window.clearTimeout(scrollStopTimer);
      scrollStopTimer = 0;
      show();
      setStuck(false);
    };

    const onMqChange = () => {
      if (mq.matches) enable();
      else disable();
    };

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMqChange);
    } else if (typeof mq.addListener === 'function') {
      // Legacy Safari
      mq.addListener(onMqChange);
    }

    onMqChange();
  };

  const setup = () => {
    setupOne({ barSelector: DESKTOP_BAR_SELECTOR, mediaQuery: DESKTOP_MQ });
    setupOne({
      resolveBar: resolveMobileStickyBarEl,
      mediaQuery: MOBILE_MQ,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();


/**
 * PWA bottom nav sits above drawer overlays on mobile, but open drawers still trap
 * touch events. Allow one-tap navigation for Home / Wishlist / Account, but not for
 * the item that toggles the same open drawer (menu or cart) â€” those must close
 * via the theme toggle without reopening.
 */
(function initPwaBottomNavDrawerClickThrough() {
  const PWA_LINK_SELECTOR = '.pwa-mob-menu';
  const PWA_DRAWER_IDS = ['sidebar-menu', 'cart-drawer'];

  const patchDialogElement = () => {
    const dialogProto = customElements.get('dialog-element')?.prototype;
    if (!dialogProto || dialogProto.__pwaOutsideClickPatched) return;

    const originalAllow = dialogProto.allowOutsideClickForTarget;
    const originalHideTarget = dialogProto.hideForOutsideClickTarget;

    dialogProto.allowOutsideClickForTarget = function (target) {
      const pwaLink = target?.closest?.(PWA_LINK_SELECTOR);
      if (!pwaLink) {
        return originalAllow.call(this, target);
      }

      const controlsId = pwaLink.getAttribute('aria-controls');
      if (controlsId && controlsId === this.id) {
        return false;
      }

      return true;
    };

    dialogProto.hideForOutsideClickTarget = function (target) {
      const pwaLink = target?.closest?.(`${PWA_LINK_SELECTOR}[aria-controls]`);
      if (pwaLink) {
        const controlsId = pwaLink.getAttribute('aria-controls');
        if (controlsId && controlsId !== this.id && PWA_DRAWER_IDS.includes(controlsId)) {
          return false;
        }
      }

      return originalHideTarget.call(this, target);
    };

    dialogProto.__pwaOutsideClickPatched = true;
  };

  if (customElements.get('dialog-element')) {
    patchDialogElement();
  } else {
    customElements.whenDefined('dialog-element').then(patchDialogElement);
  }
})();

/**
 * Reliable toggle for PWA menu / cart icons (open â†” close on repeated tap).
 * When switching sidebar â†” cart, open the new drawer instantly, then close the other (no slide animation).
 */
(function initPwaBottomNavDrawerToggle() {
  const PWA_LINK_SELECTOR = '.pwa-mob-menu[aria-controls]';
  const PWA_DRAWER_IDS = ['sidebar-menu', 'cart-drawer'];
  const SWITCHING_CLASS = 'pwa-drawer-switching';

  const closePdpCouponModals = () => {
    document
      .querySelectorAll(
        'x-modal.customer-coupons__x-modal[open], x-modal[id^="pdp-coupons-modal-"][open]'
      )
      .forEach((modal) => modal.hide?.());
  };

  const getOtherOpenDrawers = (target) =>
    PWA_DRAWER_IDS.map((id) => document.getElementById(id)).filter(
      (drawer) => drawer && drawer !== target && drawer.open
    );

  document.addEventListener(
    'click',
    async (event) => {
      const link = event.target.closest(PWA_LINK_SELECTOR);
      if (!link) return;

      const drawerId = link.getAttribute('aria-controls');
      const drawer = drawerId ? document.getElementById(drawerId) : null;
      if (!drawer || typeof drawer.hide !== 'function' || typeof drawer.show !== 'function') {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      closePdpCouponModals();

      try {
        if (drawer.open) {
          await drawer.hide();
          return;
        }

        const othersOpen = getOtherOpenDrawers(drawer);

        if (othersOpen.length > 0) {
          document.documentElement.classList.add(SWITCHING_CLASS);
          drawer.classList.add('pwa-drawer-incoming');
          try {
            const showPromise = drawer.show(false);
            await Promise.all(othersOpen.map((other) => other.hide()));
            await showPromise;
          } finally {
            drawer.classList.remove('pwa-drawer-incoming');
            document.documentElement.classList.remove(SWITCHING_CLASS);
          }
          return;
        }

        await drawer.show();
      } catch (error) {
        console.error('PWA drawer toggle failed', error);
      }
    },
    true
  );
})();

/**
 * ViSenze wigmix scanner icon lives in shadow DOM - hide unless html.canvas-app-webview.
 */
(function initWigmixScannerVisibility() {
  const WIDGET_SELECTOR = '.ps-widget-10533';
  const STYLE_ID = 'only-wigmix-scanner-visibility';
  const HIDE_RULE =
    '[data-icon-scanner="true"],' +
    '[data-icon-scanner]:not([data-icon-scanner="false"]) {' +
    'display: none !important;' +
    'visibility: hidden !important;' +
    'pointer-events: none !important;' +
    '}';

  const isCanvasApp = () => document.documentElement.classList.contains('canvas-app-webview');

  const collectShadowRoots = (node, roots = []) => {
    if (!node || typeof node.querySelectorAll !== 'function') return roots;

    if (node.shadowRoot && !roots.includes(node.shadowRoot)) {
      roots.push(node.shadowRoot);
      collectShadowRoots(node.shadowRoot, roots);
    }

    node.querySelectorAll('*').forEach((el) => {
      if (!el.shadowRoot || roots.includes(el.shadowRoot)) return;
      roots.push(el.shadowRoot);
      collectShadowRoots(el.shadowRoot, roots);
    });

    return roots;
  };

  const syncShadowRoot = (root) => {
    let style = root.getElementById(STYLE_ID);

    if (isCanvasApp()) {
      if (style) style.remove();
      return;
    }

    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      root.appendChild(style);
    }
    style.textContent = HIDE_RULE;
  };

  const syncAll = () => {
    document.querySelectorAll(WIDGET_SELECTOR).forEach((widget) => {
      collectShadowRoots(widget).forEach(syncShadowRoot);
    });
  };

  new MutationObserver(syncAll).observe(document.body, {
    childList: true,
    subtree: true,
  });

  new MutationObserver(syncAll).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  syncAll();
  window.setTimeout(syncAll, 500);
  window.setTimeout(syncAll, 1500);
  window.setTimeout(syncAll, 3000);
})();

/**
 * ViSenze re-focuses/re-renders its shadow-root search input while typing.
 * On desktop this can make the browser scroll the page upward to keep that
 * focused input in view. Keep the user's current page position stable.
 */
(function initViSenzeDesktopSearchScrollGuard() {
  const DESKTOP_WIDGET_SELECTOR = '.ps-widget-10533.expandable.wide-search-overlay';
  const SEARCH_INPUT_SELECTOR =
    '[data-pw="msb-search-bar-input"], [data-testid="wigmix-msb-search-bar-input"]';
  const DESKTOP_MQ = window.matchMedia('(min-width: 1000px)');

  const closestAcrossShadowRoots = (node, selector) => {
    let current = node;

    while (current) {
      if (current.nodeType === 1 && current.matches?.(selector)) return current;

      if (current.assignedSlot) {
        current = current.assignedSlot;
      } else if (current.parentElement) {
        current = current.parentElement;
      } else {
        const root = current.getRootNode?.();
        current = root?.host || null;
      }
    }

    return null;
  };

  const isGuardedInput = (node) => {
    return Boolean(
      DESKTOP_MQ.matches &&
        node?.matches?.(SEARCH_INPUT_SELECTOR) &&
        closestAcrossShadowRoots(node, DESKTOP_WIDGET_SELECTOR)
    );
  };

  const findGuardedInputInEvent = (event) => {
    return event.composedPath?.().find(isGuardedInput) || null;
  };

  const getDeepActiveElement = () => {
    let active = document.activeElement;

    while (active?.shadowRoot?.activeElement) {
      active = active.shadowRoot.activeElement;
    }

    return active;
  };

  const restoreIfWidgetMovedPage = (scrollX, scrollY) => {
    const active = getDeepActiveElement();
    if (!isGuardedInput(active)) return;

    // Only undo upward movement caused by the widget. Let real user scrolls pass.
    if (window.scrollY < scrollY - 1) {
      window.scrollTo({ left: scrollX, top: scrollY, behavior: 'auto' });
    }
  };

  const preserveScrollDuringInput = (event) => {
    if (!findGuardedInputInEvent(event)) return;

    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    requestAnimationFrame(() => restoreIfWidgetMovedPage(scrollX, scrollY));
    window.setTimeout(() => restoreIfWidgetMovedPage(scrollX, scrollY), 0);
    window.setTimeout(() => restoreIfWidgetMovedPage(scrollX, scrollY), 80);
  };

  ['keydown', 'beforeinput', 'input', 'keyup'].forEach((eventName) => {
    document.addEventListener(eventName, preserveScrollDuringInput, true);
  });

  const originalFocus = HTMLElement.prototype.focus;
  if (!originalFocus.__visenzeDesktopSearchGuarded) {
    HTMLElement.prototype.focus = function focusWithViSenzeScrollGuard(options) {
      if (isGuardedInput(this)) {
        const nextOptions =
          options && typeof options === 'object'
            ? { ...options, preventScroll: true }
            : { preventScroll: true };

        return originalFocus.call(this, nextOptions);
      }

      return originalFocus.apply(this, arguments);
    };

    HTMLElement.prototype.focus.__visenzeDesktopSearchGuarded = true;
  }

  const originalScrollIntoView = Element.prototype.scrollIntoView;
  if (!originalScrollIntoView.__visenzeDesktopSearchGuarded) {
    Element.prototype.scrollIntoView = function scrollIntoViewWithViSenzeGuard() {
      if (isGuardedInput(this)) return;

      return originalScrollIntoView.apply(this, arguments);
    };

    Element.prototype.scrollIntoView.__visenzeDesktopSearchGuarded = true;
  }
})();

document.addEventListener('DOMContentLoaded', function() {
  var backToTopButton = document.querySelector('[data-back-to-top]');

  if (!backToTopButton) return;

  var SHOW_OFFSET = 400; // pixels

  function toggleBackToTopVisibility() {
    if (window.scrollY > SHOW_OFFSET) {
      backToTopButton.classList.add('back-to-top--visible');
    } else {
      backToTopButton.classList.remove('back-to-top--visible');
    }
  }

  window.addEventListener('scroll', toggleBackToTopVisibility, { passive: true });

  toggleBackToTopVisibility();

  backToTopButton.addEventListener('click', function() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});

// -----------------------------------------------------------------------------
// CUSTOMER INVOICE LIST (ONLINE / OFFLINE)
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var invoiceSection = document.querySelector('.invoice-section[data-invoice-endpoint]');
  if (!invoiceSection) return;

  var phone = invoiceSection.getAttribute('data-invoice-phone') || '';
  var store = invoiceSection.getAttribute('data-invoice-store') || '';
  var endpoint = invoiceSection.getAttribute('data-invoice-endpoint') || '';

  // If phone is missing, Liquid has already rendered a helpful message.
  if (!phone || !endpoint || !store) return;

  var cache = {
    online: null,
    offline: null
  };
  var currentType = 'online';

  var tabs = invoiceSection.querySelectorAll('.invoice-tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var type = tab.getAttribute('data-invoice-type');
      if (!type || type === currentType) return;

      currentType = type;
      tabs.forEach(function (innerTab) {
        innerTab.classList.toggle('is-active', innerTab === tab);
      });

      loadInvoices(type);
    });
  });

  // Load Website (online) by default
  loadInvoices('online');

  function loadInvoices(type) {
    var tbody = invoiceSection.querySelector('.invoice-table-body');
    var errorEl = invoiceSection.querySelector('.invoice-error');
    var emptyMessageEl = invoiceSection.querySelector('.invoice-empty-message');
    var table = invoiceSection.querySelector('.invoice-table');
    if (!tbody || !errorEl) return;

    if (table) {
      table.classList.toggle('invoice-table--offline', type === 'offline');
    }

    errorEl.style.display = 'none';
    errorEl.textContent = '';
    if (emptyMessageEl) {
      emptyMessageEl.style.display = 'none';
      emptyMessageEl.textContent = '';
    }
    tbody.innerHTML =
      '<tr><td colspan="6">Loading ' + (type === 'online' ? 'website' : 'offline') + ' invoices&hellip;</td></tr>';

    if (cache[type]) {
      renderInvoices(cache[type], type);
      return;
    }

    try {
      var url = new URL(endpoint);
      url.searchParams.set('phone', phone);
      url.searchParams.set('store', store);
      url.searchParams.set('type', type);

      // Do not send credentials so the API can use a simple wildcard CORS policy.
      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(function (data) {
          if (!data || data.success !== true || !Array.isArray(data.data)) {
            throw new Error('Unexpected API response');
          }

          cache[type] = data.data;
          renderInvoices(cache[type], type);
        })
        .catch(function (error) {
          console.error('Error fetching invoices', error);
          tbody.innerHTML = '';
          errorEl.textContent = 'Unable to load invoices at the moment. Please try again later.';
          errorEl.style.display = 'block';
          if (emptyMessageEl) {
            emptyMessageEl.style.display = 'none';
            emptyMessageEl.textContent = '';
          }
        });
    } catch (e) {
      console.error('Error building invoice URL', e);
    }
  }

  function renderInvoices(list, type) {
    var tbody = invoiceSection.querySelector('.invoice-table-body');
    var emptyMessageEl = invoiceSection.querySelector('.invoice-empty-message');
    if (!tbody) return;

    if (!list || list.length === 0) {
      var message =
        type === 'offline'
          ? 'You do not have any in-store purchases yet.'
          : 'You do not have any online orders yet.';

      // Do not render an empty table row; just show the helper text below.
      tbody.innerHTML = '';

      if (emptyMessageEl) {
        emptyMessageEl.textContent = message;
        emptyMessageEl.style.display = 'block';
      }

      return;
    }

    tbody.innerHTML = '';

    if (emptyMessageEl) {
      emptyMessageEl.style.display = 'none';
      emptyMessageEl.textContent = '';
    }

    list.forEach(function (item) {
      var tr = document.createElement('tr');
      var orderNumber = item.salesOrderNumber || '';
      var invoiceNumber = item.invoiceNumber || '';
      var purchaseDate = formatInvoiceDate(item.purchaseDate);
      var amount = item.paidAmount || '';
      var invoiceDate = formatInvoiceDate(item.invoiceDate);
      var url = item.invoiceUrl || '';

      tr.innerHTML =
        '<td>' + escapeHtml(orderNumber) + '</td>' +
        '<td>' + escapeHtml(invoiceNumber) + '</td>' +
        '<td>' + escapeHtml(purchaseDate) + '</td>' +
        '<td>' + escapeHtml(amount) + '</td>' +
        '<td>' + escapeHtml(invoiceDate) + '</td>' +
        '<td class="text-end">' +
        (url
          ? '<a href="' + encodeURI(url) + '" target="_blank" rel="noopener" class="link-faded">View invoice</a>'
          : '') +
        '</td>';

      tbody.appendChild(tr);
    });
  }

  function formatInvoiceDate(raw) {
    if (!raw) return '';

    var value = String(raw).trim();

    // Handle explicit string patterns first so we don't let `new Date`
    // guess and potentially swap day & month for values like 11.03.2023.

    // Pattern like "27.12.2025" or "27.12.2025 20:24:02" (dd.MM.yyyy)
    var dotMatch = value.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
    if (dotMatch) {
      return dotMatch[1] + '/' + dotMatch[2] + '/' + dotMatch[3];
    }

    // Pattern like "2025-12-27" or "2025-12-27T15:00:25.995" (yyyy-MM-dd)
    var dashMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dashMatch) {
      return dashMatch[3] + '/' + dashMatch[2] + '/' + dashMatch[1];
    }

    // As a fallback, let the browser parse the date string if it can.
    var d = new Date(value);
    if (!isNaN(d.getTime())) {
      var dd = String(d.getDate()).padStart(2, '0');
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var yyyy = d.getFullYear();
      return dd + '/' + mm + '/' + yyyy;
    }

    // Last resort: return the original raw value
    return value;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      switch (char) {
        case '&':
          return '&amp;';
        case '<':
          return '&lt;';
        case '>':
          return '&gt;';
        case '"':
          return '&quot;';
        default:
          return '&#39;';
      }
    });
  }

/**
 * App PDP: expose product-sticky-bar height for body safe-area padding.
 */
(function initAppProductStickyBarSafeArea() {
  if (!document.documentElement.classList.contains('canvas-app-webview')) return;

  const stickyBar = document.querySelector('product-sticky-bar.product-sticky-bar');
  if (!stickyBar) return;

  const root = document.documentElement;

  const updateHeight = () => {
    root.style.setProperty('--product-sticky-bar-height', `${stickyBar.offsetHeight}px`);
  };

  updateHeight();

  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(updateHeight).observe(stickyBar);
  } else {
    window.addEventListener('resize', updateHeight);
  }

  new MutationObserver(updateHeight).observe(stickyBar, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });
})();
});
